import { Button, Form, Input, Row, Select } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { get, post } from '../../Common/api'
import GlobalContext from '../GlobalContext'
import _ from 'lodash'

export default function EventFilter ({ setLoading, getEvents, form }) {
  const [boxes, setBoxes] = useState([])
  const [tags, setTags] = useState([])
  const [tagOptions, setTagOptions] = useState({})
  const [filterOptions, setFilterOptions] = useState([])
  const [selectableFamilyTags, setSelectableFamilyTags] = useState([])
  const [selectableTags, setSelectableTags] = useState([])
  const [filters, setFilters] = useState([])
  const [currentFilter, setCurrentFilter] = useState()
  const { data } = useContext(GlobalContext)

  useEffect(() => {
    getBoxes()
    getTags()
    getFilters()
  }, [])

  useEffect(() => {
    if (currentFilter) {
      const values = filtersValue(currentFilter)
      form.setFieldsValue(values)
      selectBusinessArea(values.business_area_id)
      selectFamily(values.family_id)
      searchAction()
    }
  }, [currentFilter, form])

  useEffect(() => {
    const options = filters.map((filter) => ({ value: filter.id, label: filter.name }))
    options.push({ value: 'new', label: t('Admin.EventFilter.newFilter') })
    setFilterOptions(options)
  }, [filters])

  useEffect(() => {
    const families = sortByLabel(tags.families?.map((tag) => ({ value: tag.id, label: t(`Admin.Tag.family.${tag.name}`), business_area_id: tag.business_area_id })))
    const currentTags = sortByLabel(tags.tags?.map((tag) => ({ value: tag.id, label: t(`Admin.Tag.${tag.name}`), family_id: tag.family_id })))
    setTagOptions({
      business_areas: sortByLabel(tags.business_areas?.map((tag) => ({ value: tag.id, label: t(`Admin.Tag.businessArea.${tag.name}`) }))),
      families,
      tags: currentTags
    })
    setSelectableFamilyTags(families)
    setSelectableTags(currentTags)
  }, [tags])

  const selectBusinessArea = (businessAreaId) => {
    if (businessAreaId) {
      const currentFamilies = tagOptions.families.filter((family) => (family.business_area_id === businessAreaId))
      setSelectableFamilyTags(currentFamilies)
      setSelectableTags(tagOptions.tags.filter((tag) => (currentFamilies.map((family) => family.value).indexOf(tag.family_id) >= 0)))
    } else {
      setSelectableFamilyTags(tagOptions.families)
    }
  }

  const selectFamily = (familyId) => {
    if (familyId) {
      setSelectableTags(tagOptions.tags.filter((tag) => (tag.family_id === familyId)))
    } else {
      setSelectableTags(tagOptions.tags)
    }
  }

  const filterValue = (currentFilter, name) => {
    if ((currentFilter && currentFilter?.filters) !== undefined) {
      const value = currentFilter.filters.find((e) => e.name === name)?.value
      return value?.length > 0 ? value : undefined
    } else {
      return undefined
    }
  }

  const filtersValue = (currentFilter) => {
    const keys = ['box_id', 'period', 'resolved', 'number']
    const filter = {
      id: currentFilter.id,
      name: currentFilter.name,
      event_filter: currentFilter.id
    }
    keys.forEach((key) => {
      const value = filterValue(currentFilter, key)
      filter[key] = value
    })
    const tagId = filterValue(currentFilter, 'tag_id')
    filter.tag_id = tagId
    if (!tagId) {
      const familyId = filterValue(currentFilter, 'family_id')
      filter.family_id = familyId
      if (!familyId) {
        filter.business_area_id = filterValue(currentFilter, 'business_area_id')
      }
    }
    return filter
  }

  const getFilters = async () => {
    setLoading(true)
    await get('admin/event_filters/user', { user_id: data.user.id }, (res) => {
      setFilters(res.all)
      setCurrentFilter(res.default)
      getEvents(filtersValue(res.default))
    })
    setLoading(false)
  }

  const getTags = async () => {
    setLoading(true)
    await get('admin/tags/all', {}, (res) => {
      setLoading(false)
      setTags(res)
    }, () => {
      setLoading(true)
    })
  }

  const getBoxes = async () => {
    setLoading(true)
    await get('admin/boxes', {}, (res) => {
      setLoading(false)
      setBoxes(res.boxes.map((box) => ({ value: box.id, label: `${box.name} ${box.zip_code}` })))
    }, () => {
      setLoading(false)
    })
  }

  const onChange = (value) => {
    if (value === 'new') {
      setCurrentFilter({
        id: value,
        name: undefined,
        filters: [
          { name: 'box_id', value: '' }, { name: 'period', value: '' },
          { name: 'resolved', value: '' }, { name: 'number', value: '' },
          { name: 'business_area_id', value: '' }, { name: 'family_id', value: undefined },
          { name: 'tag_id', value: undefined }
        ]
      })
    } else {
      setCurrentFilter(filters.find((filter) => filter.id === value))
    }
  }

  const onFinish = (values) => {
    setLoading(true)
    post('admin/event_filters/save', _.merge(values, { user_id: data.user.id }), (res) => {
      setFilters(res)
      setCurrentFilter(res.find((e) => e.name === values.name))
    })
    setLoading(false)
  }

  const searchAction = () => {
    const params = form.getFieldsValue()
    if (params.tag_id) {
      delete params.family_id
      delete params.business_area_id
    }
    if (params.family_id) {
      delete params.business_area_id
    }
    getEvents(params)
  }

  const periodOptions = [
    { value: 'day', label: t('Admin.EventFilter.day') },
    { value: 'week', label: t('Admin.EventFilter.week') },
    { value: 'month', label: t('Admin.EventFilter.month') }
  ]

  const resolvedOptions = [
    { value: 'true', label: t('Admin.EventFilter.true') },
    { value: 'false', label: t('Admin.EventFilter.false') }
  ]

  const rowStyle = {
    margin: '0.5em 0'
  }

  const sortByLabel = (options) => (options?.sort((a, b) => a.label.localeCompare(b.label)))

  return (
    <div style={{ marginTop: '1em' }}>
      {
        currentFilter &&
        <Form onFinish={onFinish} form={form} layout='inline'>
          <Row style={rowStyle}>
            <Form.Item name='id' hidden>
              <Input />
            </Form.Item>
            <Form.Item name='name' rules={[{ required: true }]}>
              <Input placeholder={t('Admin.EventFilter.name')} style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='box_id'>
              <Select options={boxes} placeholder={t('Admin.EventFilter.box_id')} optionFilterProp="label" showSearch allowClear
                style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='period'>
              <Select options={periodOptions} placeholder={t('Admin.EventFilter.period')} optionFilterProp="label" showSearch allowClear
                style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='resolved'>
              <Select options={resolvedOptions} placeholder={t('Admin.EventFilter.resolved')} optionFilterProp="label" showSearch allowClear
                style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='number'>
              <Input placeholder={t('Admin.EventFilter.number')} style={{ width: '15em' }} />
            </Form.Item>
            <div style={{ display: 'flex', marginLeft: '8em' }}>
              <Form.Item name='event_filter'>
                <Select options={filterOptions} onChange={onChange} optionFilterProp="label" showSearch
                  style={{ width: '15em' }} />
              </Form.Item>
              <Button type='primary' onClick={form.submit} style={{ margin: '0 1em' }}>{t('actions.save')}</Button>
              <Button type='primary' onClick={searchAction} style={{ margin: '0 1em' }}>{t('actions.search')}</Button>
            </div>
          </Row>
          <Row style={rowStyle}>
            <Form.Item name='business_area_id'>
              <Select options={tagOptions.business_areas} className='tags'
                placeholder={t('Admin.EventFilter.business_area_id')} optionFilterProp="label" showSearch allowClear
                onChange={selectBusinessArea} style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='family_id'>
              <Select options={selectableFamilyTags} className='tags'
                placeholder={t('Admin.EventFilter.family_id')} optionFilterProp="label" showSearch allowClear
                onChange={selectFamily} style={{ width: '15em' }} />
            </Form.Item>
            <Form.Item name='tag_id'>
              <Select options={selectableTags} className='tags'
                placeholder={t('Admin.EventFilter.tag_id')} optionFilterProp="label" showSearch allowClear
                style={{ width: '15em' }} />
            </Form.Item>
          </Row>
        </Form>
      }
    </div>
  )
}
